import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { AuthService } from "./services/authService";
import { AuthProvider } from "./services/AuthContext";

/* global document, Office, module, require, HTMLElement */
let token = null;
let siteURL=""
const title = "Contoso Task Pane Add-in";
const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

// const authService = new AuthService();
// const currentUserObject = {
//   currentUserName:"",
//   currentUserId: "",
//   currentUserEmail: "",
// };
let currentUserObject={}
// async function showLoginPopup(): Promise<any> {
//   return new Promise(async (resolve, reject) => {
//     try {
//       console.log("Parent: Initiating login");
//       const authResult = await authService.login();
//       console.log("Parent: Authentication successful", authResult);
//       resolve(authResult);
//     } catch (error) {
//       console.error("Parent: Authentication failed", error);
//       reject(error);
//     }
//   });
// }



/* Render application after Office initializes */
Office.onReady(async () => {
  console.log(Office.context.mailbox.userProfile)
  token= localStorage.getItem("CurrentToken");
      currentUserObject=JSON.parse(localStorage.getItem("CurrentUser")||"{}")  ;
      siteURL=localStorage.getItem("SiteURL")||"";
  // try {
  //   await authService.initialize();
  //   const authResult = await showLoginPopup();

  //   if (authResult) {
  //     // Successfully authenticated
  //      token = authResult.accessToken;
  //      currentUserObject.currentUserName = authResult.account.name;
  //      currentUserObject.currentUserId = authResult.account.homeAccountId;
  //      currentUserObject.currentUserEmail = authResult.account.username;
      
      
  //     console.log('Authentication successful:', authResult.account.username);

  //     // localStorage.setItem("CurrentToken", token);
  //     // localStorage.setItem("CurrentUser", JSON.stringify(currentUserObject));
  //     // Example of using SharePoint service
  //     // const siteData = await sharePointService.getSiteData(token, 'your-site-id');
  //     // console.log('Site data:', siteData);
  //   }
  // } catch (error) {
  //   console.error('Authentication error:', error);
  //   const errorData = {
  //     errorMessage: error.errorCode || 'Unknown error',
  //     message: error.errorMessage || error.message,
  //     errorCode: error.stack
  //   };
  // }

  root?.render(
      // <AuthProvider>
    <FluentProvider theme={webLightTheme}>
      <App token={token} currentUser={currentUserObject} siteURL={siteURL}/>
    </FluentProvider>
      // </AuthProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
